<template>
  <div id="m-inbox" style="height: 100%">
    <v-card elevation="0">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate color="primary"/>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import { AuthStatus } from "@/store/auth";
import DeployStore from "@/modules/mdeploy/database/DeployStore";
import PermissionsStore from "@/modules/mpermissions/database/PermissionsStore";
import AudienceTestStore from "@/modules/maudiences/database/AudienceTestStore";
import firebase from "firebase";

export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    authStatus() {
      return this.$store.getters["auth/getAuthStatus"];
    },
  },
  watch: {
    authStatus(value) {
      console.log("authStatus Listener: ", value);
      if (value === AuthStatus.AUTHORIZED) {
        console.warn("Authorized UID:", firebase.auth().currentUser?.uid);
        this.fetchApi();
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  methods: {
    safeUnregisterModule(name) {
      if (this.$store.hasModule(name)) {
        this.$store.unregisterModule(name);
      }
    },
    async fetchApi() {
      console.log("fetchApi ->");
      this.loading = true;

      const modules = [
        { name: "deploy-store", store: DeployStore },
        { name: "permissions-store", store: PermissionsStore },
        { name: "audience-test-store", store: AudienceTestStore }
      ];

      try {
        for (const { name, store } of modules) {
          this.safeUnregisterModule(name);
          this.$store.registerModule(name, store);
        }

        await Promise.all(modules.map(({ name }) =>
          this.$store.dispatch(`${name}/init`).then(() => {
            console.log(`Loaded successfully: ${name}`);
          }).catch(error => {
            this.$notify({ title: name, text: error.message || error, type: "error" });
            console.error(`Error in ${name}:`, error);
          })
        ));

        console.log("COMPLETE ALL");
        await this.$router.push({path: "/m-configs"});

      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    console.log("Home created");
    if (this.authStatus === AuthStatus.AUTHORIZED) {
      console.warn("Authorized UID:", firebase.auth().currentUser?.uid);
      this.fetchApi();
    }
  }
};
</script>
